
import * as konfettiRuntime$3d7m1VqGQC from '/app/providers/konfetti.ts'
import * as ipxRuntime$7hTYQt1c7w from '/app/node_modules/.pnpm/@nuxt+image@1.2.0_@netlify+blobs@8.2.0_db0@0.3.2_ioredis@5.6.1_magicast@0.3.5_rollup@4.44.2/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['konfetti']: { provider: konfettiRuntime$3d7m1VqGQC, defaults: undefined },
  ['ipx']: { provider: ipxRuntime$7hTYQt1c7w, defaults: {} }
}
        